import { oz } from '@weft/utils';
import { PerUnitPricingConfigurationSchema } from './per-unit/per-unit-pricing-configuration-schema';
import { TieredSubscriptionPricingConfigurationSchema } from './tiered-subscription/tiered-subscription-pricing-configuration-schema';
import { TiersPricingConfigurationSchema } from './tiers/tiers-pricing-configuration-schema';

export const UsagePricingConfigurationSchema = oz.union([
  PerUnitPricingConfigurationSchema,
  TiersPricingConfigurationSchema,
  TieredSubscriptionPricingConfigurationSchema,
]).openapi('UsagePricingConfiguration');

export type UsagePricingConfiguration = oz.infer<typeof UsagePricingConfigurationSchema>;